<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <h4 class="text-h4">Order Fulfillment Report</h4>
                <p class="text-subtitle-1">Purchase Orders Fulfillment Report</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-text-field
                    label="filter"
                    v-model="filter"
                    prepend-inner-icon="mdi-filter"
                    shaped
                    filled
                    dense
                    single-line
                    hide-details>
                </v-text-field>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-progress-linear indeterminate v-if="loading"/>
            <v-col>
                <v-data-table
                    dense
                    :headers="headers"
                    :items="list"
                    :search="filter"
                    show-group-by
                    disable-pagination
                    hide-default-footer>
                    <template v-slot:[`item.supplier_name`]="{item}">
                        <router-link :to="`/purchase/supplier/${item.supplier_id}`">{{item.supplier_name}}</router-link>
                    </template>

                    <template v-slot:[`item.purchase_order_code`]="{item}">
                        <router-link :to="`/purchase/order/${item.purchase_order_id}`">{{item.purchase_order_code}}</router-link>
                    </template>

                    <template v-slot:[`item.quantity`]="{item}">
                        {{formatNumber(item.quantity, 2)}}
                    </template>

                    <template v-slot:[`item.received`]="{item}">
                        <v-icon left x-small :color="dotColor(item.quantity, item.received)">mdi-circle</v-icon>
                        {{formatNumber(item.received, 2)}}
                    </template>

                    <template v-slot:[`item.billed`]="{item}">
                        <v-icon left x-small :color="dotColor(item.quantity, item.billed)">mdi-circle</v-icon>
                        {{formatNumber(item.billed, 2)}}
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { formatNumber } from 'accounting';
import permissions from './../../data/permissions';
import { getOrdersFulfillment } from '../../services/purchase/reports'

export default {
    name: "PurchaseOrderFullfillment",
    data() {
        return {
            headers: [
                { text: "Purchase Order", value: "purchase_order_code" },
                { text: "Date", value: "purchase_order_date" },
                { text: "Supplier", value: "supplier_name" },
                { text: "Item", value: "item_name" },
                { text: "Quantity", value: "quantity", groupable: false},
                { text: "Received", value: "received", groupable: false },
                { text: "Billed", value: "billed", groupable: false }
            ],
            loading: false,
            list:[],
            filter: "",
            permissions: permissions
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        }),
        // filterdList() {
        //     return this.list.filter( each => {
        //         return each.purchase_order_code.toLowerCase().indexOf(this.filter) > -1 ||
        //                 each.supplier_name.toLowerCase().indexOf(this.filter) > -1 ||
        //                 each.item_name.toLowerCase().indexOf(this.filter) > -1
        //     });
        // }
    },
    methods: {
        formatNumber,
        dotColor(orderQuantity, quantity) {
            orderQuantity = Number(orderQuantity)
            quantity = Number(quantity)
            if(quantity == 0) return "error";
            if(quantity < orderQuantity) return "warning";
            if(quantity == orderQuantity) return "success";
            return "grey lighten-3"
        },
        async getOrdersFulfillment() {
            try {
                this.loading = true;
                let res = await getOrdersFulfillment();
                this.list = res.data;
            }finally {
                this.loading = false;
            }
        },
        isCompleted(v) {
            if(v.received == 0 && v.billed == 0) {
                return false;
            }

            let completed = (v.received == v.billed);

            return completed;
        },
        handleRowClicked(item) {
            this.$router.push({ name: "PurchaseOrderDisplay", params: {id: item.purchase_order_id} })
        }
    },
    created() {
        this.getOrdersFulfillment();
    }
}
</script>

<style>

</style>